"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTRIBUTION_CONSTS = void 0;
exports.ATTRIBUTION_CONSTS = {
    ExternalIdentifierMetadataKey: 'attributionExternalIdentifier',
};
